<template>
  <div id="LoginForm" class="uk-width-5-6">
    <h2 class="gr-texte-black">Vous avez oublié votre mot de passe</h2>
    <p class="gr-texte gr-texte-black">Veuillez saisir votre identifiant (adresse mail) et vous recevrez un email contenant le lien vous permettant de modifier votre mot de passe.</p>
    <form class="uk-form-stacked" @submit.prevent="forgot()">
      <div class="uk-margin" v-if="!success">
        <label class="uk-form-label gr-form-label gr-texte-black" for="form-stacked-text">Votre Email<sup>*</sup></label>
        <div class="uk-form-controls">
            <input name="email" class="uk-input gr-form-input" v-model="input.email" type="email" autocapitalize="none" autocorrect="off" spellcheck="false" placeholder="Votre email">
        </div>
      </div>
      <div v-if="success" class="uk-margin uk-alert-success" uk-alert>
        {{success}}
      </div>
      <div v-if="errors" class="uk-margin uk-alert-danger" uk-alert>
         <a class="uk-alert-close" uk-close></a>
        {{errors}}
      </div>
      <div class="uk-margin uk-margin-medium-top uk-flex uk-flex-column">
        <div v-if="!success">
          <button type="submit" class="uk-button cta-sfr-primary" :disabled="loading">{{ loading ? 'Envoi en cours...' : 'Envoyer' }}</button>
        </div>
        <div>
          <a @click.prevent="retour()" class="gr-link-form">Retour à la connexion</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ForgotForm',
  data() {
      return {
          input: {
              email: "",
          },
          errors:null,
          success:null,
          loading:false,
      }
  },
  computed: {
    tokenAuth () {
      return this.$store.state.tokenAuth
    }
  },
  methods: {
      retour(){
        this.$store.commit('gotoForgot',{forgotform:false});
      },
      forgot() {
          const email = this.input.email.trim().toLowerCase();
          this.errors = null;
          this.success = null;

          if(email == "") {
            this.errors = "Veuillez renseigner votre adresse email.";
            return;
          }
          if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            this.errors = "Cette adresse email n'est pas valide.";
            return;
          }

          this.loading = true;
          axios.post(this.$store.state.urlws+'forgotmdp',{email:email})
          .then(response => {
            this.success = "Si un compte existe avec cette adresse, un email de réinitialisation vient d'être envoyé. Pensez à vérifier vos spams.";
            this.loading = false;
          })
          .catch(e => {
            const errs = (e.response && e.response.data && e.response.data.messages) ? e.response.data.messages.errors : null;
            if(errs && errs.email){
              this.errors = errs.email;
            }
            else{
              this.errors = "L'envoi a échoué. Merci de réessayer dans quelques instants.";
            }
            this.loading = false;
          })
      }
  }
}
</script>
